import {
  doesFocusableExist,
  getCurrentFocusKey,
  setFocus,
} from "@noriginmedia/norigin-spatial-navigation";

export function isPhoneLoginFocusKey(focusKey) {
  return (
    typeof focusKey === "string" &&
    (focusKey.indexOf("phone-key-") === 0 ||
      focusKey === "phone-submit" ||
      focusKey === "phone-delete")
  );
}

export function focusPhoneLoginDefaultOnce(defaultedRef) {
  var currentFocusKey = getCurrentFocusKey();

  if (defaultedRef && defaultedRef.current) return;

  if (isPhoneLoginFocusKey(currentFocusKey)) {
    if (defaultedRef) defaultedRef.current = true;
    return;
  }

  if (!doesFocusableExist("phone-key-9")) return;

  setFocus("phone-key-9", { skipScroll: true });

  if (getCurrentFocusKey() === "phone-key-9" && defaultedRef) {
    defaultedRef.current = true;
  }
}

export function focusLoginMenu() {
  var targetFocusKeys = ["menu_login", "MENU"];
  var i;

  for (i = 0; i < targetFocusKeys.length; i += 1) {
    if (!doesFocusableExist(targetFocusKeys[i])) continue;

    setFocus(targetFocusKeys[i], { skipScroll: true });
    if (
      typeof getCurrentFocusKey() === "string" &&
      getCurrentFocusKey().indexOf("menu_") === 0
    ) {
      return false;
    }
  }

  return true;
}
